<div *ngIf="!chapters?.length" class="empty-list">
    <i class="bi bi-book empty-list__icon"></i>
    <span class="empty-list__text">{{ noDataText ?? 'No chapters assigned this week.' }}</span>
</div>

<div class="chapter-list" *ngIf="chapters?.length > 0">
    <div
        class="chapter-item"
        *ngFor="let chapter of chapters ?? []; trackBy: trackByChapterCode">

        <div class="chapter-item__top d-flex align-items-center justify-content-between mb-1">
            <div class="d-flex align-items-center gap-1 chapter-item__title-group">
                <span class="chapter-item__title">{{ chapter.title }}</span>
                <button
                    class="chapter-item__info-btn"
                    type="button"
                    (click)="openInfo(chapter)"
                    *ngIf="chapter.id && careProgramId"
                    aria-label="Chapter info">
                    <i class="bi bi-info-circle"></i>
                </button>
            </div>
            <span class="chapter-item__status">
                <i class="bi bi-check2 status-done" *ngIf="chapter.completed || chapter.progressValue >= 1"></i>
                <span
                    class="pct-label"
                    *ngIf="!chapter.completed && chapter.progressValue > 0 && chapter.progressValue < 1">
                    {{ chapter.progressValue * 100 | number:'1.0-0' }}%
                </span>
            </span>
        </div>

        <div class="progress chapter-bar">
            <div
                class="progress-bar chapter-bar__fill"
                [class.chapter-bar__fill--complete]="chapter.completed"
                [style.width.%]="chapter.progressValue * 100"
                role="progressbar">
            </div>
        </div>
    </div>
</div>
